import { render, staticRenderFns } from "./shopping-caozuo.vue?vue&type=template&id=6beeb4b2&scoped=true"
import script from "./shopping-caozuo.vue?vue&type=script&lang=js"
export * from "./shopping-caozuo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beeb4b2",
  null
  
)

export default component.exports